import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { gridSpacing } from 'store/constant';
import LoaderCustom from 'ui-component/LoaderCustom';
import { SET_SIDE_MENU } from 'store/actions';
import { CLEAR_CAMPAIGN_LIST } from '../redux/advertiser/advertiserTypes';
import { fetchCTVCampaignsForAdvertiser } from '../redux/advertiser/advertiserActions';
import SearchBarCTV from 'components/Dashboard/SearchBarCTV';
import CTVSection from 'components/ctv/CTVReportView';

const SECTIONS = [
  { key: 'overall', title: 'Overall Advertiser Performance', dimensionField: 'advertiser_name', dimensionHeader: 'Advertiser' },
  { key: 'creative', title: 'Creative Level Performance', dimensionField: 'creative_name', dimensionHeader: 'Creative Name' },
  { key: 'campaign', title: 'Campaign Level Performance', dimensionField: 'campaign_name', dimensionHeader: 'Campaign Name' },
  { key: 'supply', title: 'Supply Level Performance', dimensionField: 'supply_app_id', dimensionHeader: 'Supply App ID' },
  { key: 'exchange', title: 'Exchange Level Performance', dimensionField: 'exchange', dimensionHeader: 'Exchange' }
];

const CTVPage = ({ advertiserList, ctvState, startDate, endDate }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.setItem('showSideMenu', true);
    dispatch({ type: SET_SIDE_MENU, showSideMenu: true });

    dispatch({ type: CLEAR_CAMPAIGN_LIST });
    const advertiserGuid = localStorage.getItem('advertiserId');
    const sfId = localStorage.getItem('sfId') || '';
    if (advertiserGuid && startDate && endDate) {
      dispatch(fetchCTVCampaignsForAdvertiser(advertiserGuid, sfId, startDate, endDate));
    }
  }, [dispatch, startDate, endDate]);

  if (advertiserList.length === 0) {
    return <LoaderCustom />;
  }

  return (
    <>
      <Paper elevation={1} spacing={gridSpacing} className="stickyBox">
        <SearchBarCTV />
      </Paper>
      <Grid container spacing={gridSpacing} sx={{ mt: 0 }}>
        {SECTIONS.map((sec) => (
          <Grid item xs={12} key={sec.key}>
            <CTVSection
              title={sec.title}
              dimensionField={sec.dimensionField}
              dimensionHeader={sec.dimensionHeader}
              loading={ctvState.loading}
              rows={ctvState[sec.key]}
              error={ctvState.error}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  advertiserList: state.advertiserReducer.advertiser_list,
  ctvState: state.ctvReducer,
  startDate: state.campaignReducer.start_date,
  endDate: state.campaignReducer.end_date
});

export default connect(mapStateToProps)(CTVPage);
